import { Grid, GridProps, Stack, styled, Table, TableHead, TableRow } from '@mui/material';
import { SPACE_BETWEEN } from 'constant';

export const StyleSkeletonTable = styled(Table)(() => ({
  border: '1px solid #C0C7CA',
  borderRadius: '8px',
  '&.MuiTable-root': {
    borderCollapse: 'separate !important',
  },
}));

export const StackHeading = styled(TableHead)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: SPACE_BETWEEN,
  backgroundColor: '#f5f5f5',
  '&.MuiTableHead-root': {
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
  },
}));

export const StyleContainerGrid = styled(Grid)<GridProps>(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '10px',
}));

export const StyleStartGrid = styled(Grid)<GridProps>(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const StyleEndGrid = styled(Grid)<GridProps>(() => ({
  display: 'flex',
  justifyContent: 'end',
  alignItems: 'center',
}));

export const StyleButtonGrid = styled(Grid)<GridProps>(() => ({
  alignItems: 'center',
  width: '100%',
}));

export const StyleTableRow = styled(TableRow)(() => ({
  display: 'flex',
  justifyContent: SPACE_BETWEEN,
  alignItems: 'center',
}));

export const StyleDiv = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const StyleEndDiv = styled(Stack)(() => ({
  justifyContent: 'end',
  alignItems: 'center',
}));

export const StyleFooter = styled(Grid)<GridProps>(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));
